import { useEffect, useRef } from "react";

export const Loader = () => {
  const ref = useRef(null);
  const doneRef = useRef(false);

  const hide = () => {
    const el = ref.current;
    if (!el || doneRef.current) return;
    doneRef.current = true;
    el.style.transition = "opacity 0.7s ease";
    el.style.opacity = "0";
    el.style.pointerEvents = "none";
    window.setTimeout(() => {
      if (el) el.style.display = "none";
    }, 750);
  };

  useEffect(() => {
    const t = window.setTimeout(hide, 2000);
    const events = ["wheel", "scroll", "touchstart", "keydown"];
    events.forEach((e) => window.addEventListener(e, hide, { passive: true }));
    return () => {
      clearTimeout(t);
      events.forEach((e) => window.removeEventListener(e, hide));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={ref}
      data-testid="intro-loader"
      onClick={hide}
      onPointerDown={hide}
      style={{ opacity: 1 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0a0a0c]"
    >
      <div className="relative flex flex-col items-center">
        <div className="overflow-hidden">
          <h1
            aria-label="EUROSTEEL"
            className="wordmark-reveal font-body select-none text-[13vw] font-light uppercase leading-none tracking-[0.32em] text-[#c6a87c] sm:text-[7vw] lg:text-[5.5rem]"
          >
            <span className="pl-[0.32em]">EUROSTEEL</span>
          </h1>
        </div>

        <div className="mt-10 h-px w-[220px] overflow-hidden bg-white/10">
          <div className="loader-line h-full bg-[#c6a87c]" />
        </div>

        <p className="loader-fade-in font-tech mt-5 text-[10px] uppercase tracking-[0.5em] text-white/40">
          Steel Craftsmanship
        </p>
      </div>
    </div>
  );
};
